module.exports = __webpack_public_path__ + "static/media/Sentient_MoveList.9f59fe9e.png";